/**
 * Sends a payload through the Android WebView bridge.
 *
 * Keep serialization here so every feature uses the same native boundary.
 */
export function sendToAndroid(payload) {
  const bridge =
    window.Android ??
    (window.parent !== window ? window.parent.Android : undefined);

  if (!bridge?.sendDataFromJS) {
    throw new Error("Android bridge is not available");
  }

  bridge.sendDataFromJS(JSON.stringify(payload));
}

export function createAndroidMessage(type, requestName, response = {}) {
  return {
    transferData: [
      {
        type,
        request: { name: requestName },
        response,
        name: "",
      },
    ],
  };
}

export function sendAndroidMessage(type, requestName, response = {}) {
  sendToAndroid(createAndroidMessage(type, requestName, response));
}

export function parseAndroidMessage(message) {
  const envelope =
    typeof message === "string" ? JSON.parse(message) : message;
  const request =
    typeof envelope.request === "string"
      ? JSON.parse(envelope.request)
      : envelope.request;
  const response =
    typeof envelope.response === "string"
      ? JSON.parse(envelope.response)
      : envelope.response;

  return {
    name: request?.name,
    url: request?.url,
    data: response?.data,
  };
}
